import { render, staticRenderFns } from "./PnPConf.vue?vue&type=template&id=53cc5c4f"
import script from "./PnPConf.vue?vue&type=script&lang=js"
export * from "./PnPConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports